<template>
  <div class="pie">
    <div class="echart" ref="pie" />
    <div class="red" v-if="data.length > 0">
      图片位置保存到桌面!
    </div>
    <el-button v-if="data.length > 0" @click="save">保存</el-button>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { DownloadFile, arrayReduce } from '../utils/common.js';

export default {
  name: 'pie',
  data() {
    return {
      data: [],
      Chart: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      const data = JSON.parse(localStorage.getItem('errorStatistics'));
      const list = arrayReduce(data.list, 'type');
      if(list.length > 0) {
        const str = [];
        for (const key in list) {
          str.push({
            name: list[key].type.split('：')[0],
            value: list[key].appearTotal,
          });
        }
        this.data = str;
        this.getpie();
      }
    })
  },
  methods: {
    getpie() {
      this.Chart = echarts.init(this.$refs.pie);
      const option = {
        animation: false,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: '5%',
          left: 'center',
          formatter: function(name) {
            let data = option.series[0].data;
            let total = 0;
            let tarValue = 0;
            for(let i = 0, l = data.length; i < l; i++) {
              total += data[i].value;
              if(data[i].name == name) {
                tarValue = data[i].value;
              }
            }
            let p = (tarValue / total * 100).toFixed(2);
            return name + ' ' + tarValue + '（' + p +')'+ '%';
          }
        },
        series: [
          {
            name: '饼图',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
          
            itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
            },
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: '40',
                    fontWeight: 'bold'
                }
            },
            labelLine: {
              show: false
            },
            data: this.data
          }
        ]
      };
      this.Chart.setOption(option);
    },
    save() {
      let path = this.Chart.getDataURL({
        backgroundColor: '#fff'
      });
      DownloadFile(path, (path) => {
        console.log(path)
        this.$message({
          message: '已保存到桌面！',
          type: 'success'
        });
        setTimeout(() => {
          window.close();
        }, 2000)
      }, 'test.png')
    },
  }
};
</script>

<style scoped>
.pie {
  width: 100%;
  height: 100%;
  text-align: center;
}

.echart {
  width: 100%;
  height: 85%;
}

.red {
  font-size: 12px;
  padding-bottom: 10px;
  color: red;
}
</style>